var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#35518A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7488 33.7551C28.6421 33.7551 26.4025 33.7558 25.3696 33.7547C24.8378 33.7544 24.6481 33.5633 24.6481 33.0282C24.6474 31.6535 24.6471 30.2789 24.6481 28.9043C24.6484 28.3759 24.849 28.1743 25.374 28.174C26.4069 28.1733 28.6343 28.1736 28.7488 28.1736C28.7488 28.0795 28.7485 26.0949 28.7488 25.181C28.7495 23.8298 28.9906 22.5364 29.677 21.3522C30.3798 20.1401 31.4025 19.3098 32.7132 18.8298C33.5527 18.5221 34.4241 18.3993 35.3149 18.3986C36.4294 18.398 37.544 18.399 38.6588 18.401C39.1379 18.4017 39.3504 18.6135 39.3514 19.096C39.3534 20.389 39.3534 21.682 39.3514 22.9747C39.3507 23.4623 39.1471 23.6581 38.6571 23.6635C37.7435 23.6734 36.8293 23.6673 35.9167 23.704C34.995 23.704 34.5101 24.1542 34.5101 25.1082C34.488 26.1173 34.501 27.1275 34.501 28.1733C34.5873 28.1733 37.2104 28.173 38.4365 28.1733C38.9934 28.1733 39.1838 28.3647 39.1838 28.9247C39.1838 30.2918 39.1834 31.6593 39.1824 33.0265C39.1821 33.5783 39.0032 33.7544 38.4429 33.7547C37.2169 33.7554 34.604 33.7551 34.4897 33.7551V44.8204C34.4897 45.4103 34.3041 45.5983 33.722 45.5983C32.3029 45.5983 30.8834 45.5986 29.4642 45.5983C28.9498 45.5983 28.7492 45.3984 28.7492 44.884C28.7488 41.2803 28.7488 33.8816 28.7488 33.7551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.2655db1e5c62fba993860c6ae1c47bdf.svg";
export { ForwardRef as ReactComponent };